/**
 * name: The name of the environment. Used in title
 * slug: The slug to use in the URL
 * env: The gym.js env. Used to index into `gym`.
 * phaser: Whether the environment is a phaser env and
 *      thus requires slightly different use.
 * settings: A list of the editable settings.
 * defaults: A list in the same order above of the default values.
 * description: a description of the environment
 */

module.exports = [
    {
        name: "Frozen Lake",
        slug: "frozenlake",
        env: "FrozenLake",
        phaser: false,
        settings: [
            {
                name: "mapSize",
                values: [4,8],
                helpText: "The size of the map."
            },
            {
                name: "p",
                values: {min:0,max:1},
                helpText: "The probability of slipping."
            },
            {
                name: "isSlippery",
                values: [true, false],
                helpText: "Enable slipping."
            }
        ],
        defaults: [
            8,
            0.8,
            true
        ],
        description: `You and your friends were playing frisbee when the frisbee was mistakenly thrown out onto a
        frozen lake. The lake has several holes in it and is also slippery so you don't always move in the direction
        that you want to. Also, the world is in an international frisbee shortage and thus it is vital to retrieve the
        item.`
    },
    {
        name: "Snake",
        slug: "snake",
        env: "Snake",
        phaser: true,
        settings: null
            // {
            //     name: "headless",
            //     values: [true,false],
            //     helpText: "Run the environment headlessly."
            // },
        ,
        defaults: null,
            // false
        description: `The game of Snake.`,
    },
    {
        name: "Algorithmic: Copy",
        slug: "copy",
        env: "Copy",
        phaser: false,
        settings: null,
        defaults: null,
        description: `A 1 dimensional environment where you must copy the input tape to the output tape.`
    },
    {
        name: "Algorithmic: Reverse",
        slug: "reverse",
        env: "Reverse",
        phaser: false,
        settings: null,
        defaults: null,
        description: `A 1 dimensional environment where you must reverse the input tape to the output tape.`
    }
];
